/* unplugin-vue-components disabled */import script from "./QueryMyself.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryMyself.vue?vue&type=script&setup=true&lang=js"

import "./QueryMyself.vue?vue&type=style&index=0&id=987046c8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-987046c8"]])

export default __exports__